import { call, put } from 'redux-saga/effects'
import { toast } from 'react-toastify'
import {
  requestEditShift,
  requestListShift,
  requestCreateShift,
  requestDeleteShifts,
  requestShiftAppointments,
} from '../requests/shiftService'
import {
  setLoading,
  setShifts,
  setError,
  setUpdatedShift,
  setNewShift,
  setProcessing,
  removeShift,
  setShiftAppointmentError,
  setShiftAppointments,
  setShiftAppointmentLoading 
} from 'redux/slices/shiftSlice'

export function* handleShiftsGet() {
  try {
    yield put(setLoading())
    const response = yield call(() => requestListShift())
    yield put(setShifts(response.data))
  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message
    yield put(setError(errorMsg ))
  }
}

export function* handleCreateShift(action) {
  try {
    yield put(setProcessing(true))
    const response = yield call(() => requestCreateShift(action.payload))
    yield put(setNewShift(response.data))
    toast.success('Shift Created')
  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message
    toast.error(`Error: ${errorMsg}`)
  } finally {
    yield put(setProcessing(false))
  }
}

export function* handleDeleteShifts(action) {
  try {
    yield put(setProcessing(true))
    yield call(() => requestDeleteShifts(action.payload))
    yield put(removeShift(action.payload))
    toast.success('Shift Deleted')
  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message
    toast.error(errorMsg)
  } finally {
    yield put(setProcessing(false))
  }
}

export function* handleEditShifts(action) {
  try {
    yield put(setProcessing(true))
    const response = yield call(() => requestEditShift(action.payload))
    yield put(setUpdatedShift(response.data))
    toast.success('Shift Updated')
  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message
    toast.error(errorMsg)
  } finally {
    yield put(setProcessing(false))
  }
}

export function* handleGetShiftAppointments(action) {
  try {
    yield put(setShiftAppointmentLoading())
    const response = yield call(() => requestShiftAppointments(action.payload))
    yield put(setShiftAppointments(response.data))
  } catch (e) {
    const errorMsg = e.response ? e.response.data.message : e.message
    yield put(setShiftAppointmentError(errorMsg))
  }
}
